import { useNavigate } from 'react-router-dom';
import { UnauthMain } from './UnauthorizedStyles.styles';
import React, { Suspense } from 'react';
import HelmetHelper from '../Components/PageHelmet/HelmetHelper.component';
// Lazy-load components
const PrimaryButton = React.lazy(
  () => import('../Components/Buttons/PrimaryButton/PrimaryButton.component')
);

const Unauthorized = () => {
  const navigate = useNavigate();

  const goHome = (e) => {
    e.preventDefault();
    navigate('/');
  };

  return (
    <UnauthMain>
      <Suspense fallback={<div>Loading...</div>}>
        <HelmetHelper
          title="Unauthorized"
          description="You do not have permission to access this page."
          noIndex
        />
      </Suspense>
      <div>
        <h2>You are unauthorized</h2>
        <Suspense fallback={<div>Loading button...</div>}>
          <PrimaryButton functionName={goHome} span="Go Home" />
        </Suspense>
      </div>
    </UnauthMain>
  );
};

export default Unauthorized;
